// Formatting + small helpers. Currency RM, dates DD/MM/YYYY, week starts Monday.

export function rm(value, opts = {}) {
  const n = Number(value || 0);
  const s = n.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return opts.noPrefix ? s : `RM ${s}`;
}

export function fmtDate(input) {
  if (!input) return "—";
  const d = typeof input === "string" && input.length === 10 ? new Date(input + "T00:00:00") : new Date(input);
  if (isNaN(d)) return input;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function fmtDateTime(input) {
  if (!input) return "—";
  const d = new Date(input);
  if (isNaN(d)) return input;
  return `${fmtDate(d)} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function monthRange(date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth();
  const start = new Date(y, m, 1);
  const end = new Date(y, m + 1, 0);
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  return { start: iso(start), end: iso(end) };
}

export function lastMonthRange() {
  const d = new Date();
  return monthRange(new Date(d.getFullYear(), d.getMonth() - 1, 1));
}

export function yearRange() {
  const y = new Date().getFullYear();
  return { start: `${y}-01-01`, end: `${y}-12-31` };
}

// Minimal robust CSV parser -> { headers, rows: [{...}] }
export function parseCSV(text) {
  const lines = [];
  let field = "", row = [], inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (c === '"') inQuotes = false;
      else field += c;
    } else {
      if (c === '"') inQuotes = true;
      else if (c === ",") { row.push(field); field = ""; }
      else if (c === "\n") { row.push(field); lines.push(row); row = []; field = ""; }
      else if (c === "\r") { /* skip */ }
      else field += c;
    }
  }
  if (field.length || row.length) { row.push(field); lines.push(row); }
  const nonEmpty = lines.filter((r) => r.some((v) => String(v).trim() !== ""));
  if (!nonEmpty.length) return { headers: [], rows: [] };
  const headers = nonEmpty[0].map((h) => h.trim());
  const rows = nonEmpty.slice(1).map((r) => {
    const o = {};
    headers.forEach((h, idx) => (o[h] = (r[idx] ?? "").trim()));
    return o;
  });
  return { headers, rows };
}

export const CATEGORY_LABELS = {
  development: "Development",
  finance: "Finance",
  operation: "Operation",
  maintenance: "Maintenance",
  general_update: "General Update",
  // Legacy labels remain readable for items created before the dashboard redesign.
  branch_issue: "Branch Issue",
  development_update: "Development Update",
  equipment_request: "Equipment Request",
  campaign_request: "Campaign Request",
  supplier_payment_request: "Supplier Payment Request",
  incident: "Incident",
  maintenance_issue: "Maintenance Issue",
};

export const ROLE_LABELS = {
  super_admin: "System Admin",
  management: "Management / GM",
  director: "Director",
  branch_manager: "Branch Manager",
  staff: "Branch Staff",
};
